import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";

import row1 from "./data/row1.json";
import row2 from "./data/row2.json";
import row3 from "./data/row3.json";
import row4 from "./data/row4.json";
import row5 from "./data/row5.json";
import row6 from "./data/row6.json";

class Export extends Component {
  constructor(props) {
    super(props);

    this.state = {
      row1: row1.row1,
      row2: row2.row2,
      row3: row3.row3,
      row4: row4.row4,
      row5: row5.row5,
      row6: row6.row6
    };
  }

  render() {
    return (
      <div>
        <ul>
          {this.state.row1.map((item, i) => (
            <li>
              {item.abbreviation} - {item.label}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.content
                }}
              />
            </li>
          ))}
          {this.state.row2.map((item, i) => (
            <li>
              {item.abbreviation} - {item.label}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.content
                }}
              />
            </li>
          ))}
          {this.state.row3.map((item, i) => (
            <li>
              {item.abbreviation} - {item.label}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.content
                }}
              />
            </li>
          ))}
          {this.state.row4.map((item, i) => (
            <li>
              {item.abbreviation} - {item.label}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.content
                }}
              />
            </li>
          ))}
          {this.state.row5.map((item, i) => (
            <li>
              {item.abbreviation} - {item.label}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.content
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default Export;
